import type { DeepWritable } from '@cmg/common';
import type { CustomCellRendererProps, GridState } from '@cmg/data-grid';
import { getColDefId, getDataSource } from '@cmg/data-grid';
import { useMemo } from 'react';

import { RolodexRecordStatus } from '../../../../../../graphql';
import statusColDef from '../../columns/status';
import type { UnderwriterEmployeeFragment } from './graphql/__generated__';
import { useSalesCoverageUnderwriterEmployeesGridQuery } from './hooks/useSalesCoverageUnderwriterEmployeesGridQuery';

export type SalesCoverageGridCellRendererProps<TValue> = CustomCellRendererProps<
  UnderwriterEmployeeFragment,
  TValue
>;

export const INITIAL_SALES_COVERAGE_GRID_STATE: GridState = {
  filter: {
    filterModel: {
      [getColDefId(statusColDef)]: {
        values: [RolodexRecordStatus.Effective],
        filterType: 'set',
      },
    },
  },
};

export function useDataSource({ tenantId }: { tenantId?: string }) {
  const loadRows = useSalesCoverageUnderwriterEmployeesGridQuery(tenantId);

  return useMemo(() => {
    return getDataSource({
      getData: async variables => {
        const { data, error } = await loadRows({
          where: {
            ...variables.where,
          },
          order: variables.order,
        });
        if (error) {
          throw error;
        }

        const rowData = (data?.underwriterEmployees?.items ?? []) as DeepWritable<
          UnderwriterEmployeeFragment[]
        >;
        const rowCount = rowData.length;
        return {
          rowData,
          rowCount,
        };
      },
    });
  }, [loadRows]);
}
